import { useState } from "react";
import { Document, Page } from 'react-pdf';
//import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';


import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import productFileApi from "../../api/productFileApi";
import Pagination from "../Commons/Pagination";
import ActionButton from "../Commons/ActionButton";
import useLog from "../../hooks/useLog";

import { getLabel } from "../../tools/Dictionary";
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { MdClose, MdDownload } from "react-icons/md";

const ProductFileDisplayModal = (props) =>
{

  //Logs
  const { logUserAction } = useLog();

  //Props
  const IsDesktop = props.IsDesktop;
  const OnCloseModal = props.OnCloseModal;
  const Data = props.Data;
  const Type = props.Type; 

  //State
  const [media, setMedia] = useState(undefined);
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale] = useState(1.0);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() => {

    logUserAction("View Product File", { fileId: Data._id, fileName: Data.name });
    loadData();

  });
  

  const loadData = async () =>
  {


    try
    {

      setLoading(true);

      let response = await productFileApi.downloadProductFile(Data._id || Data.id);

      const blob = new Blob([response], {
        type: Data.type
      });


      setMedia(URL.createObjectURL(blob));

      if (Type != "pdf")
        setLoading(false);

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }

  };

  const onDocumentLoadSuccess = (_data) => {

    try{

      setNumPages(_data._pdfInfo.numPages);
      setLoading(false);


    }catch{

      setNumPages(0);

    }

    
  };


  const onClickDownload = () => {

    if (!loading && media){

      logUserAction("Download Product File", { fileId: Data._id, fileName: Data.name });

      // Create an anchor element
      const a = document.createElement('a');
      a.href = media;
      a.download = Data.name + "." + Data.format;

      // Append the anchor element to the document body
      document.body.appendChild(a);

      // Programmatically trigger a click event on the anchor element to initiate the download
      a.click();

      // Cleanup: Remove the anchor element and revoke the temporary URL
      document.body.removeChild(a);
    }

  };

  const onCloseModal = () => {

    if (media) URL.revokeObjectURL(media);

    OnCloseModal();

  };

  if (!Data) return null;



  return (
    <div className="page_modal_background">
      <div className="processfile_display_page_cont" >
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
            {Type == "image" && 
              <div className="processfile_display_media_cont" style={{alignItems: "flex-start", marginTop: "50px"}}> 
                <div className="processfile_display_media_page_cont" style={{height: "50px"}}>
                  <div className="processfile_display_media_page_col" style={{ width: "30%" }} >
                    <ActionButton
                      IsDesktop={IsDesktop}
                      Label={getLabel("FileController", "Download")}
                      Icon={MdDownload}
                      OnClick={onClickDownload}
                    />
                  </div>
              <div className="processfile_display_media_page_col processfile_display_media_file_title">
                    {Data.name}
                  </div>
                  <div className="processfile_display_media_page_col" style={{ width: "30%" }} >
                    <ActionButton
                      IsDesktop={IsDesktop}
                      Label={getLabel("App", "Close")}
                      Icon={MdClose}
                      OnClick={onCloseModal}
                    />
                  </div>
                </div>
                <div style={{margin: "auto"}}>
                  <img
                    src={media}
                    alt={Data.name}
                  />
                </div>
              </div>
            }
            {Type == "pdf" && 
              <div className="processfile_display_media_cont" style={{alignItems: "flex-start", marginTop: "50px"}}> 
            <div className="processfile_display_media_page_cont" style={{ height: "50px" }}>
                  <div className="processfile_display_media_page_col" style={{width: "30%"}}>
                    <ActionButton
                      IsDesktop={IsDesktop}
                      Label={getLabel("FileController", "Download")}
                      Icon={MdDownload}
                      OnClick={onClickDownload}
                    />
                  </div>
                  <div className="processfile_display_media_page_col">
                    <Pagination
                      IsDesktop={IsDesktop}
                      data={{
                        page: pageNumber,
                        perPage: 1
                      }}
                      onChangePage={(_page) => setPageNumber(_page)}
                      count={numPages}
                    />
                  </div>
                  <div className="processfile_display_media_page_col" style={{width: "30%"}} >
                    <ActionButton
                      IsDesktop={IsDesktop}
                      Label={getLabel("App", "Close")}
                      Icon={MdClose}
                      OnClick={OnCloseModal}
                    />
                  </div>
                </div>
                <div style={{margin: "auto"}}>
                  <Document 
                    file={media}
                    onLoadSuccess={onDocumentLoadSuccess}
                    className="flex flex-col items-center"
                    loading={null}
                  >
                    <Page pageNumber={pageNumber} scale={scale} 
                    />
                  </Document>
                </div>
              </div>
            }
          </div>
    </div>
  );

};

export default ProductFileDisplayModal